import type { V2ColorValue } from "../types"

/** Default v2 hue ramps from `v2/styles/colors.css` (OC-2). Alpha ramps live in CSS only. */
export const V2_PRIMITIVES_DEFAULT: Record<string, V2ColorValue> = {
  "v2-grey-50": "#ffffffff",
  "v2-grey-100": "#fafafaff",
  "v2-grey-200": "#f2f2f2ff",
  "v2-grey-300": "#eeeeeeff",
  "v2-grey-400": "#dbdbdbff",
  "v2-grey-500": "#aeaeaeff",
  "v2-grey-600": "#808080ff",
  "v2-grey-700": "#5c5c5cff",
  "v2-grey-800": "#3a3a3aff",
  "v2-grey-900": "#2e2e2eff",
  "v2-grey-1000": "#242424ff",
  "v2-grey-1100": "#161616ff",
  "v2-grey-1200": "#080808ff",
  "v2-red-100": "#fcecebff",
  "v2-red-200": "#f6d5d3ff",
  "v2-red-300": "#f2bbb7ff",
  "v2-red-400": "#f29b96ff",
  "v2-red-500": "#f17471ff",
  "v2-red-600": "#f1484fff",
  "v2-red-700": "#d92e3cff",
  "v2-red-800": "#b82d35ff",
  "v2-red-900": "#97252bff",
  "v2-red-1000": "#7a1f23ff",
  "v2-red-1100": "#5f1a1cff",
  "v2-red-1200": "#461516ff",
  "v2-orange-100": "#fdf2edff",
  "v2-orange-200": "#ffe7dcff",
  "v2-orange-300": "#ffd8c6ff",
  "v2-orange-400": "#ffc1a4ff",
  "v2-orange-500": "#ffa478ff",
  "v2-orange-600": "#ff8648ff",
  "v2-orange-700": "#ee7330ff",
  "v2-orange-800": "#d16427ff",
  "v2-orange-900": "#b35624ff",
  "v2-orange-1000": "#954c27ff",
  "v2-orange-1100": "#723d22ff",
  "v2-orange-1200": "#5a2c14ff",
  "v2-yellow-100": "#fefaecff",
  "v2-yellow-200": "#fcefd0ff",
  "v2-yellow-300": "#f7e5b5ff",
  "v2-yellow-400": "#f3da9bff",
  "v2-yellow-500": "#f2cf76ff",
  "v2-yellow-600": "#f6c251ff",
  "v2-yellow-700": "#e7af36ff",
  "v2-yellow-800": "#cb9f34ff",
  "v2-yellow-900": "#ac8833ff",
  "v2-yellow-1000": "#8e7231ff",
  "v2-yellow-1100": "#68552bff",
  "v2-yellow-1200": "#4b4025ff",
  "v2-green-100": "#e7f9eaff",
  "v2-green-200": "#d0f0d5ff",
  "v2-green-300": "#b8e9c1ff",
  "v2-green-400": "#96e3a6ff",
  "v2-green-500": "#6bd586ff",
  "v2-green-600": "#49c970ff",
  "v2-green-700": "#2eaf5aff",
  "v2-green-800": "#198b43ff",
  "v2-green-900": "#1d783cff",
  "v2-green-1000": "#196130ff",
  "v2-green-1100": "#164c26ff",
  "v2-green-1200": "#14361dff",
  "v2-cyan-100": "#e2f7fbff",
  "v2-cyan-200": "#c4edf4ff",
  "v2-cyan-300": "#a3e4efff",
  "v2-cyan-400": "#65d9ebff",
  "v2-cyan-500": "#00c5dfff",
  "v2-cyan-600": "#00abcfff",
  "v2-cyan-700": "#0096b8ff",
  "v2-cyan-800": "#007d9bff",
  "v2-cyan-900": "#006c85ff",
  "v2-cyan-1000": "#005a6eff",
  "v2-cyan-1100": "#004756ff",
  "v2-cyan-1200": "#00353fff",
  "v2-blue-100": "#ecf1feff",
  "v2-blue-200": "#d7e2fcff",
  "v2-blue-300": "#c3d4fdff",
  "v2-blue-400": "#a2bcffff",
  "v2-blue-500": "#7698fdff",
  "v2-blue-600": "#3b5cf6ff",
  "v2-blue-700": "#3250dfff",
  "v2-blue-800": "#2c47c8ff",
  "v2-blue-900": "#263fa9ff",
  "v2-blue-1000": "#22388fff",
  "v2-blue-1100": "#1c2e70ff",
  "v2-blue-1200": "#1b2852ff",
  "v2-purple-100": "#ebecfeff",
  "v2-purple-200": "#d5d5fcff",
  "v2-purple-300": "#b9b8f5ff",
  "v2-purple-400": "#9e99f7ff",
  "v2-purple-500": "#8271f8ff",
  "v2-purple-600": "#7152f4ff",
  "v2-purple-700": "#623be2ff",
  "v2-purple-800": "#5230c2ff",
  "v2-purple-900": "#442aa1ff",
  "v2-purple-1000": "#361f83ff",
  "v2-purple-1100": "#2b1b6aff",
  "v2-purple-1200": "#221358ff",
  "v2-pink-100": "#fdecf3ff",
  "v2-pink-200": "#f7d5e4ff",
  "v2-pink-300": "#fabcd8ff",
  "v2-pink-400": "#f799c6ff",
  "v2-pink-500": "#f26cb2ff",
  "v2-pink-600": "#f64aabff",
  "v2-pink-700": "#e4429eff",
  "v2-pink-800": "#c83d8bff",
  "v2-pink-900": "#aa3576ff",
  "v2-pink-1000": "#8c2d61ff",
  "v2-pink-1100": "#6f284fff",
  "v2-pink-1200": "#5c1d3fff",
}
